module.exports = __webpack_public_path__ + "img/logo.c1655712.png";